import { Container, Row, Col } from "react-bootstrap";
import { MailchimpForm } from "./MailchimpForm";
import logo from "../assets/img/logo.png";
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon4 from "../assets/img/nav-icon4-2.png";

export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          <MailchimpForm />
          <Col xs={6} sm={6} className="d-flex align-items-center">
            <img src={logo} alt="Logo" />
          </Col>
          <Col xs={6} sm={6} className="text-end">
            <div className="social-icon d-flex justify-content-end w-100">
              <a href="https://linkedin.com/in/filipszmid/"><img src={navIcon1} alt="" /></a>
              <a href="https://github.com/FilipSzmid"><img src={navIcon4} alt="" /></a>
            </div>
            <p className="mt-2">Copyright 2023. All Rights Reserved</p>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}
